

import firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firebase-firestore';


 
  var firebaseConfig = {
    apiKey : "AIzaSyDjzWFCi8nv-B2k4zuCoYENReS7X2P1o2o" , 
  authDomain : "hojouzate-admin.firebaseapp.com" , 
  databaseURL : "https://hojouzate-admin-default-rtdb.firebaseio.com" , 
  projectId : "hojouzate-admin" , 
  storageBucket : "hojouzate-admin.appspot.com" , 
  messagingSenderId : "1000195606030" , 
  appId : "1:1000195606030:web:06347eae48cc9217125e5f" , 
  measurementId : "G-YD2Q1B70SR"
  };
 
  firebase.initializeApp(firebaseConfig);
  export default firebase;
  
